<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <div class="tercero-table-block mt-4" v-if="listContratos?.length > 0">
            <CorporateDataTable
                :items="listadoContratosFormat"
                :fields="allFields"
                :filter-defs="tableFilterDefs"                
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                @row-clicked="(item) => detalleContrato(item.id,item.nro_contrato)"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="abrirDetalle" v-if="showBtn">
                        Detalle
                    </b-button>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="abrirActivos" v-if="showBtn">
                        Activos
                    </b-button>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="abrirCuotas" v-if="showBtn">
                        Cuotas
                    </b-button>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="$router.push({ name: 'CrearContrato' })">
                        {{ labels.addContrato }}
                    </b-button>
                    <b-button style="background-color: #2e507a; width: 30px; height: 30px;" class="md-fab md-primary" @click="genExcelContratos()">
                        <i>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg> 
                        </i>
                    </b-button>
                </template>
                <template #cell(estado)="data">
                    <div class="text-left">{{ data.item.estado == 'Inicial' ? 'Vigente' : data.item.estado }}</div>
                </template>
            </CorporateDataTable>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <!-- <Crear :modalCrear="showCreaContrato" @cierraModal="closeModal"></Crear> -->
        <Detalle :modalDetalle="showDetalleContrato" :infoContrat="detailContrato" @cierraModal="closeModal"></Detalle>
        <ModTerminaContrato :modTermContr="showModTermContracto" :nroContrato="numContrato" @cierraModal="closeModal"></ModTerminaContrato>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato'; 
import Tercero from '../../services/Tercero'; 
import TipoContrato from '../../services/TipoContrato' 
// import Crear from './Crear.vue'; 
import Detalle from './Detalle.vue'; 
import ModTerminaContrato from './ModTerminaContrato.vue'; 
import CorporateDataTable from '../utils/CorporateDataTable.vue'
import * as XLSX from "exceljs";

export default {
    name: 'Consultar',
    components : {
        // Crear,
        Detalle,
        ModTerminaContrato,
        CorporateDataTable
    },
    data: () => ({
        numContrato : '',
        listContratos : [],
        listTipoContrato : [],
        listTercero : [],
        listTipoAct : [],
        listActivo : [],
        // showCreaContrato : false,
        showDetalleContrato : false,
        showModTermContracto : false,
        detailContrato : [],
        showBtn : false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Lista contratos',
                    noRow : "No hay registros",
                    addContrato : 'Añadir contrato',
                    nroContrato : "Contrato", 
                    contrato : "Contrato", 
                    arrendador : 'Arrendador',
                    fechaActivacion : 'Fecha activación',
                    fechaInicial : 'Fecha inicial',
                    fechaFinal : 'Fecha final',
                    fechaEstado : 'Fecha estado',
                    tipoContrato : 'Tipo contrato',
                    valorContrato : 'Valor contrato',
                    estado : 'Estado',
                    filterContrato : 'Filtrar contrato...',
                    filterArrendador : 'Filtrar arrendador...',
                    filterTipoContrato : 'Filtrar tipo contrato...',
                    filterValContrato : 'Filtrar valor contrato...',
                    filterFechaInicial : 'Filtrar fecha inicial...',
                    filterFechaFinal : 'Filtrar fecha final...',
                    filterFechaEstado : 'Filtrar fecha estado...',
                    filterEstado : 'Filtrar estado...'
                }
            }else{
                return {
                    title : 'Contracts list',
                    noRow : "There are not records",
                    addContrato : 'Add contract',
                    nroContrato : "Contract",
                    contrato : "Contract",
                    arrendador : 'Lessor',
                    fechaActivacion : 'Activation date',
                    fechaInicial : 'Strating date',
                    fechaFinal : 'End date',
                    fechaEstado : 'Status date',
                    tipoContrato : 'Contract type',
                    valorContrato : 'Contract value',
                    estado : 'State',
                    filterContrato : 'Filter contract...',
                    filterArrendador : 'Filter landlord...',
                    filterTipoContrato : 'Filter by contract type...',
                    filterValContrato : 'Filter by contract value...',
                    filterFechaInicial : 'Filter by start date...',
                    filterFechaFinal : 'Filter by end date...',
                    filterFechaEstado : 'Filter by date status...',
                    filterEstado : 'Filter by status...'
                }
            }
        },
        allFields(){
            return [
                { key: 'nro_contrato', label: this.labels.contrato, sortable: true, thClass: 'text-center', tdClass: 'text-center', thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } },
                { key: 'identificacion', label: this.labels.arrendador, sortable: true, thClass: 'text-center', tdClass: 'text-start', thStyle: { whiteSpace: 'nowrap', minWidth: '500px' } },
                { key: 'tipo_contrato', label: this.labels.tipoContrato, sortable: true, thClass: 'text-center', tdClass: 'text-start', thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'valor_contrato', label: this.labels.valorContrato, sortable: true, thClass: 'text-center', tdClass: 'text-end', thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'fecha_inicial', label: this.labels.fechaInicial, sortable: true, thClass: 'text-center', tdClass: 'text-start', thStyle: { whiteSpace: 'nowrap', minWidth: '130px' } },
                { key: 'fecha_final', label: this.labels.fechaFinal, sortable: true, thClass: 'text-center', tdClass: 'text-start', thStyle: { whiteSpace: 'nowrap', minWidth: '130px' } },
                { key: 'fecha_estado', label: this.labels.fechaEstado, sortable: true, thClass: 'text-center', tdClass: 'text-start', thStyle: { whiteSpace: 'nowrap', minWidth: '130px' } },
                { key: 'estado', label: this.labels.estado, sortable: true, thClass: 'text-center', tdClass: 'text-start', thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'nro_contrato', type: 'text', placeholder: this.labels.filterContrato },
                { key: 'identificacion', type: 'text', placeholder: this.labels.filterArrendador },
                { key: 'tipo_contrato', type: 'text', placeholder: this.labels.filterTipoContrato },
                { key: 'valor_contrato', type: 'text', placeholder: this.labels.filterValContrato },
                { key: 'fecha_inicial', type: 'text', placeholder: this.labels.filterFechaInicial },
                { key: 'fecha_final', type: 'text', placeholder: this.labels.filterFechaFinal },
                { key: 'fecha_estado', type: 'text', placeholder: this.labels.filterFechaEstado },
                { key: 'estado', type: 'text', placeholder: this.labels.filterEstado },
            ]
        },
        listadoContratosFormat() {
            return this.listContratos.map(item => ({
                ...item,
                identificacion: this.showArrendador(item.identificacion),
                tipo_contrato: this.showTipoContrato(item.tipo_contrato),
                valor_contrato: this.formatNumber(item.valor_contrato)
            }));
        }
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        abrirDetalle(){
            this.$router.push({
                name: 'ConsultarDetalle',
                params: {
                    id: this.detailContrato.id
                }
            })
        },
        abrirActivos(){
            this.$router.push({
                name: 'ConsultarActivos',
                params: {
                    contrato: this.detailContrato.nro_contrato
                }
            })
        },
        abrirCuotas(){
            this.$router.push({
                name: 'ConsultarCuotas',
                params: {
                    contrato: this.detailContrato.nro_contrato
                }
            })
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 })?.format(value); 
        },
        filtrarPorContrato(item, filtro) {
            if (!filtro) return true
            const texto = filtro.toString().toLowerCase() 
            return item.nro_contrato.toString().toLowerCase()?.includes(texto) 
        },
        detalleContrato(id,nroContrato){

            if(this.$route.name == 'terminacioncontrato'){ 
                this.showModTermContracto = true 
                this.numContrato = nroContrato 
            
            }else if(this.$route.name == 'consultarcontrato'){ 

                Contrato.getContratoById(id) 
                .then((res) => { 
                    this.detailContrato = res.data.contractById[0] 
                    // this.showDetalleContrato = true 
                    this.showBtn = true
                })
                .catch((err) => console.log(err)) 
            }

        },
	showArrendador(identify){
		if	(identify == null || identify == undefined) {
			return identify
		}
  let nameTercero = this.listTercero.find((tercer) => tercer.identificacion === identify) 

		if	(nameTercero == undefined) {
			return "Sin Nombre "+identify
		}
  return nameTercero?.nombre 
	},
        showTipoContrato(tipContrato){
		if	(tipContrato == null || tipContrato == undefined) {
			return tipContrato
		}
            let tipoContrato = this.listTipoContrato.find((tipoContact) => tipoContact.tipo_contrato === tipContrato) 
            return tipoContrato?.descripcion 
        },
        closeModal(val){
            // this.showCreaContrato = val 
            this.showDetalleContrato = val 
            this.showModTermContracto = val 
        },
        async genExcelContratos(){

            const { Workbook } = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Lista contratos") 

            // =======================
            // TÍTULO
            // =======================
            worksheet.addRow(['Lista contratos']) 
            worksheet.mergeCells('A1:H1') 

            const titleCell = worksheet.getCell('A1'); 
            titleCell.font = { name: 'Arial', size: 12, bold: true }; 
            titleCell.alignment = { horizontal: 'center' }; 

            // =======================
            // FILA 2 - INFO GENERAL (richText)
            // =======================
            worksheet.addRow(['']); 
            worksheet.mergeCells('A2:H2'); 

            const cell2 = worksheet.getCell('A2'); 

            cell2.value = { 
                richText: [
                    { text: 'Fecha generación: ', font: { bold: true } },
                    { text: `${this.fechaActual()} |` }, 

                    { text: 'Generado por: ', font: { bold: true } },
                    { text: `${this.$store.state.userName}` }, 
                ]
            };

            cell2.font = { name: 'Arial', size: 12 }; 
            cell2.alignment = { horizontal: 'center', vertical: 'middle' }; 


            // =======================
            // FILA 3 - MÁS INFO (richText)
            // =======================
            worksheet.addRow(['']); 
            worksheet.mergeCells('A3:H3'); 

            worksheet.addRow(['']); 
            worksheet.mergeCells('A4:H4') 

            // =======================
            // HEADER TABLA
            // =======================
            const headerRow = worksheet.addRow([ 
                'Nro. contrato', 
                'Arrendador',
                'Tipo contrato',
                'Valor contrato',
                'Fecha inicial',
                'Fecha final',
                'Fecha estado',
                'Estado'
            ])

            headerRow.font = { name: 'Arial', size: 11, bold: true } 
            headerRow.alignment = { horizontal: 'center' } 

            // =======================
            // DATA
            // =======================
            this.listadoContratosFormat.forEach(e => { 
                worksheet.addRow([ 
                    e.nro_contrato, 
                    e.identificacion, 
                    e.tipo_contrato, 
                    e.valor_contrato, 
                    e.fecha_inicial, 
                    e.fecha_final, 
                    e.fecha_estado, 
                    e.estado == 'Inicial' ? 'Vigente' : e.estado
                    // this.formatDecimal(e.tasa), 
                    // this.formatNumber(e.valor_canon), 
                    // this.formatNumber(e.activo_derecho_uso_bruto), 
                    // this.formatNumber(e.gasto_amortizacion), 
                    // this.formatNumber(e.amortizacion_acumulada), 
                    // this.formatNumber(e.cambio_pasivo), 
                    // this.formatNumber(e.activo_derecho_uso_neto), 
                ])
            })

            // =======================
            // ANCHO COLUMNAS
            // =======================
            worksheet.columns = [ 
                { width: 10 },
                { width: 15 },
                { width: 10 },
                { width: 15 },
                { width: 18 },
                { width: 15 },
                { width: 15 },
                { width: 15 },
            ]

            // =======================
            // BORDES
            // =======================
            const border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }

            worksheet.eachRow({ includeEmpty: false }, row => { 

                if ([1, 2, 3, 4].includes(row?.number)) return; // 👈 omitir filas 
                row.eachCell(cell => { 
                    cell.border = border 
                })
            })
            
            const file = await workbook.xlsx.writeBuffer() 
            const downloadLink = document.createElement("a") 
            downloadLink.download = "Lista contratos.xlsx" 
            downloadLink.href = window.URL.createObjectURL( 
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                })
            )

            downloadLink.style.display = "none" 
            document.body.appendChild(downloadLink) 
            downloadLink.click() 
            downloadLink.remove()
        },
        fechaActual(){
            const fecha = new Date()

            const año = fecha.getFullYear() 
            const mes = String(fecha.getMonth() + 1).padStart(2, '0') // getMonth() va de 0 a 11 
            const dia = String(fecha.getDate()).padStart(2, '0') 

            return `${año}-${mes}-${dia}`
        }
    },
    mounted(){
        // console.log(this.listadoContratosFormat,'EEEEE');
        Contrato.getAllContratos() 
        .then((res) => { 
            this.listContratos = res.data.listContratos 
        })
        .catch((err) => console.log(err)) 

        Tercero.getAllTercero() 
        .then((res) => { 
            this.listTercero = res.data.listTercero 
        })
        .catch((err) => console.log(err)) 

        TipoContrato.getAllTipoContrato() 
        .then((res) => { 
            this.listTipoContrato = res.data.listTipoContrato 
        })
        .catch((err) => console.log(err)) 
    }
}
</script>
<style src="../main.css"> 
</style>
